import { Component, OnInit } from '@angular/core';
import {
  ConfigurationService,
  DetailSearchConfiguration,
  IncidentalAbsenceSearch,
  InpageAliasService,
  OmniApi,
  SearchRequest,
  Session,
  TranslationService,
} from 'src/app/my-sedgwick';
import { BaseComponent, LoadingState } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../../models/aliases';

@Component({
    selector: 'app-off-work-page',
    template: `
    <app-section>
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb></app-claim-breadcrumb>
      </div>
      <app-panel
        [title]=""
        [noTranslationText]="employeeTitle"
        [headerLevel]="1"
        class="tw-w-full"
        [canExpand]="false"
        >
        <div class="tw-min-h-[510px] tw-w-full">
          <app-tab-group
            [hideSingleTab]="true"
            [selectedIndex]="0"
            [sectionName]="'Employees Off Work'"
            >
            <app-tab
              label="Claims"
              [template]="offWorkClaims"
              featureName="OffWorkClaims"
              >
              <ng-template #offWorkClaims>
                @if (showAbsences) {
                  <div class="tw-pt-4"></div>
                }
                <app-detail-search-form
                  #searchForm
                  [config]="config"
                  (search)="search($event)"
                  [loading]="loading"
                  [translationRequest]="translationRequest"
                  >
                  <ng-template #results>
                    <app-search-count-row
                      [count]="offWorks.length"
                      [detail]="employeeLabel?.value"
                      [isInDirectInclude]="isInDirectReporting"
                      [isSupervisor]="isSupervisorSelect"
                      [supervisorFullName]="SupervisorFullName"
                    ></app-search-count-row>
                    <app-off-work
                      [offWork]="offWorks"
                      class="tw-w-full"
                      (export)="searchForm.appendExport($event)"
                      [translationRequest]="translationRequest"
                    />
                  </ng-template>
                </app-detail-search-form>
              </ng-template>
            </app-tab>
            <app-tab
              label='{{ "Absences" | translation: translationRequest }}'
              [badge]=""
              [visible]="showAbsences"
              [template]="offWorkAbsences"
              featureName="OffWorkAbsences"
            >
              <ng-template #offWorkAbsences>
                <app-absence-case-search
                  [initialSearch]="true"
                  [initialValue]="absenceSearch"
                  [translationRequest]="translationRequest"
                  [fromSummaryView]="true"
                ></app-absence-case-search>
              </ng-template>
            </app-tab>
          </app-tab-group>
        </div>
      </app-panel>
    </app-section>
  `,
  styles: ``,
  standalone: false,
})
export class OffWorkPageComponent extends BaseComponent implements OnInit {
  config = new DetailSearchConfiguration();

  loading: LoadingState;

  offWorks: any[];

  employeeLabel: Aliases;

  employeeTitle: string = '';

  showAbsences = false;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Search',
    subGroup: 'Search',
  });

  absenceSearch = new IncidentalAbsenceSearch();

  isSupervisorSelect : boolean = false;
  SupervisorFullName : string = '';
  isInDirectReporting : boolean = true;
  
  constructor(
    private omniApi: OmniApi,
    private aliases: InpageAliasService,
    private configuration: ConfigurationService,
    private translationService: TranslationService,
    private session: Session
  ) {
    super();
    this.config.key = 'omni-dashboard:off-work';
    this.config.setVisibility(false);
    this.config.firstName.visible = true;
    this.config.lastName.visible = true;
    this.config.employeeId.visible = true;
    this.config.initialSearch = true;
    this.config.initialSearchResultsOnClear = true;
    this.config.managerLookupSupervisor = false;
    this.config.showParametersToggle = true;
    this.config.expanded = false;
    this.config.claimNumber.visible = true;
    this.config.payType.visible = false;
  }

  loadTranslations(): void {
    this.translationRequest.contNum = Number(this.session.user.contNum);
    this.translationService.getTranslation(this.translationRequest);
  }


  async ngOnInit() {
    this.loadTranslations();
    const config = await this.configuration.getAdditionalUserInformation();
    this.employeeLabel = await this.aliases.replaceAliases(
      'employeePlural',
      config.configFeatures.aliases
    );
    const employeeAlias = this.employeeLabel.value;

   let managerEmpUnum = '';
    if(this.verifyFilterByManager())
    {      
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      
      managerEmpUnum = supervisor.empUnum;
    }
   
    let includeIndirectReports = false;
     if (this.verifyIndirectReport()) {
      const includeIndirectsInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'includeIndirects_summary'
      );
      includeIndirectReports = includeIndirectsInSession.toLowerCase() == 'true';
    }
   

     
    this.omniApi.getOmniDashboard(managerEmpUnum , includeIndirectReports).then((dashboard) => {
      this.employeeTitle =
        dashboard.employeesOffWork + ' ' + employeeAlias + ' ' + this.translationService.getTranslationForKey('off work', this.translationRequest);
    });
    this.showAbsences = this.configuration.getConfigFeatureAccess(
      'IncidentalAbsences5'
    );
    

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.absenceSearch.startDate = today;
    this.absenceSearch.endDate = today;

    if(this.verifyFilterByManager())
    {
      this.isSupervisorSelect = this.verifyFilterByManager();
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      this.SupervisorFullName = supervisor.name;
      this.isInDirectReporting = this.verifyIndirectReport();
    }


  }

   verifyIndirectReport() {
    const includeIndirectsInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'includeIndirects_summary'
    );

    if (includeIndirectsInSession == undefined || includeIndirectsInSession == null || includeIndirectsInSession.length < 2) {
      return false;
    }
    else {
      return includeIndirectsInSession.toLowerCase() == 'true';
    }


  }
  verifyFilterByManager() {
    const filteredManagerInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'filteredManager_summary'
    );

    if (filteredManagerInSession == undefined || filteredManagerInSession == null || filteredManagerInSession.length < 2) {
      return false;
    }
    else {
      return true;
    }
  }


  override ngOnDestroy(): void {
    this.config.initialSearch = true;
  }

  async search(request: SearchRequest) {
    this.loading = 'Loading';

     const searchParam  = request.getParameters();
   
    if(this.verifyFilterByManager())
    {      
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      searchParam.supervisor = supervisor;
      searchParam.managerEmpUnum = supervisor.empUnum;
    }
    else{
      searchParam.supervisor = null;
      searchParam.managerEmpUnum = null;
    }

     if (this.verifyIndirectReport()) {
      const includeIndirectsInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'includeIndirects_summary'
      );
      searchParam.includeIndirectReports = includeIndirectsInSession.toLowerCase() == 'true';
    }
    else {
      searchParam.includeIndirectReports = false;
    }
   
    this.offWorks = await this.omniApi.getOffWorks(searchParam);
    this.loading = this.offWorks.length > 0 ? 'Loaded' : 'Empty';
    this.config.initialSearch = false;
  }
}
